import { render } from "./ChangeRoleForm.vue?vue&type=template&id=28e2d2c7&scoped=true"
import script from "./ChangeRoleForm.vue?vue&type=script&lang=js"
export * from "./ChangeRoleForm.vue?vue&type=script&lang=js"

import "./ChangeRoleForm.vue?vue&type=style&index=0&id=28e2d2c7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28e2d2c7"]])

export default __exports__